import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  updateFolder(request: Boundaries["updateFolder"]["request"]): void;
}

function useUpdateFolder(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isUpdateFolderRequestPending),
    isRequestSuccess: useSelector(selector.isUpdateFolderRequestSuccess),
    isRequestFailure: useSelector(selector.isUpdateFolderRequestFailure),
    updateFolder: core.updateFolder,
  };
}

export { useUpdateFolder };
